import React from 'react'
import {
  Breadcrumb as BreadcrumbUiComponent,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator,
} from '@repo/ui/components'
import { type IBreadcrumbData } from './breadcrumb.types'
import { Link } from '@repo/shared/i18n/navigation'

export interface IBreadcrumbProps {
  data: IBreadcrumbData[]
}

export const Breadcrumb = (props: IBreadcrumbProps) => {
  const { data } = props
  return (
    <BreadcrumbUiComponent>
      <BreadcrumbList className='flex-nowrap whitespace-nowrap'>
        {data.map((item, idx) => (
          <React.Fragment key={item.key || item.label}>
            <BreadcrumbItem>
              {item.href ? (
                <BreadcrumbLink as={Link} href={item.href}>
                  {item.label}
                </BreadcrumbLink>
              ) : (
                <BreadcrumbPage>{item.label}</BreadcrumbPage>
              )}
            </BreadcrumbItem>
            {idx < data.length - 1 && (
              <BreadcrumbSeparator>/</BreadcrumbSeparator>
            )}
          </React.Fragment>
        ))}
      </BreadcrumbList>
    </BreadcrumbUiComponent>
  )
}
